import { TagValue, TagValueQuery } from "ng/src/app/tags/tag.model";
import { Component, Injector, Input } from "@angular/core";
import { TagService } from "ng/src/app/tags/tag.service";
import { Observable } from "rxjs";
import { PagedArray } from "app/shared/model/app.model";
import { QuerySelectorComponent } from "ng/src/app/shared/item-selectors/query-selector/query-selector.component";
import { QuerySelectorType } from "ng/src/app/shared/item-selectors/query-selector/query-selector.model";


@Component({
	selector: `
		tag-selector:[logId]:not([parentTagId]):not([depth]),
		tag-selector[logId][parentTagId]
	`,
	templateUrl: '../shared/item-selectors/query-selector/query-selector.component.html',
	styleUrls: ['../shared/item-selectors/query-selector/query-selector.component.scss'],
	providers: [QuerySelectorComponent.ProviderAccessor(TagSelectorComponent)]
})
export class TagSelectorComponent extends QuerySelectorComponent<TagValue, TagValueQuery> {
	@Input()
	logId!: number
	
	@Input()
	parentTagId?: number;
	
	@Input()
	depth?: number;
	
	
	displayField: keyof TagValue = "viewString";
	idField: keyof TagValue = "id";
	pageSize = 100;
	readonly type = QuerySelectorType.Multiple;
	
	constructor(
		private tagService: TagService,
		injector: Injector
	) {
		super(injector);
	}
	
	protected fetch(query: TagValueQuery): Observable<PagedArray<TagValue>> {
		return this.tagService.fetchTagValues(query);
	}
	
	protected constructQuery(query: string): TagValueQuery {
		const params: TagValueQuery = {
			log: this.logId,
			matches: query,
			sort: 'viewString,asc'
		}
		
		if (typeof this.parentTagId === 'number') {
			params.parentDepthSpec = {
				tagId: this.parentTagId,
				depth: this.depth
			}
		}
		
		return params;
	}
}